import { Message } from 'element-ui';
import store from '../store';
import router from '../router/index.js';

var fly=require("flyio")
fly.config.timeout=10000;
fly.config.baseURL='https://ceshi.damuzhiyingyu.com:444/web/';
// fly.config.baseURL='http://localhost:12300/web/';

//添加请求拦截器
fly.interceptors.request.use((request)=>{
  let info = store.getters.getInfo
  
  if (info!=null) {
    let token = info.token;
    request.headers = {
      'accessToken': token
    }
  }
  return request;
})

//添加响应拦截器，响应拦截器会在then/catch处理之前执行
fly.interceptors.response.use(
  (response) => {
    let res = response.data;
    
    if (res.statusCode == 20000) {
      return res.data
    } else {
      Message.error(res.statusMessage);
    }
  },
  (err) => {
    if(err.status == 40301) {
      Message.error('您已被登出,请重新登录!');
      router.push('login')
    }
  }
)

export default fly;